import React from 'react';
import { SelectInput } from '@abyss/web/ui/SelectInput';
import { IconMaterial } from '@abyss/web/ui/IconMaterial';
import { styled } from '@abyss/web/tools/styled';
import PropTypes from 'prop-types';

const CustomSelectInput = styled(SelectInput, {
  variants: {
    color: {
      error: {
        '&.abyss-select-input-input': {
          color: '$error1 !important',
        },
      },
    },
  },
});

export const StyledSelectInput = ({ isError, ...rest }) => {
  return (
    <CustomSelectInput
      {...rest}
      isDisabled={isError}
      color={isError ? 'error' : ''}
      inputLeftElement={
        isError ? (
          <IconMaterial
            icon="error"
            size="18px"
            color="$error1"
            isScreenReadable
            title="Favorite"
          />
        ) : null
      }
    />
  );
};

StyledSelectInput.propTypes = {
  isError: PropTypes.bool,
};

StyledSelectInput.defaultProps = {
  isError: false,
};
